import { 
    createAction
} from 'redux-actions'

import { actions } from '../constants'
import { dynamicGroupsApiService } from '../api'

const { DYNAMIC_CHANNELS } = actions

export const dynamicChannelsActions = {

    /**
     * Start loading
     */
    start: createAction(DYNAMIC_CHANNELS.START),

    /**
     * Start loading channel types
     */
    startTypes: createAction(DYNAMIC_CHANNELS.START_TYPES),

    /**
     * Start loading channel instances
     */
    startInstances: createAction(DYNAMIC_CHANNELS.START_INSTANCES),
    
    /**
     * Show error messages
     */
    error: createAction(DYNAMIC_CHANNELS.ERROR),

    /**
     * Show success messages
     */
    success: createAction(DYNAMIC_CHANNELS.SUCCESS),

    /**
     * reset data
     */
    reset: createAction(DYNAMIC_CHANNELS.RESET),
    
    /**
     * Save dynamic channels
     */
    saveDynamicChannels: createAction(DYNAMIC_CHANNELS.SAVE),
    
    /**
     * Save channel types
     */
    saveChannelTypes: createAction(DYNAMIC_CHANNELS.SAVE_CHANNEL_TYPES),
    
    /**
     * Save channel instances
     */
    saveChannelInstances: createAction(DYNAMIC_CHANNELS.SAVE_CHANNEL_INSTANCES),
    
    /**
     * Clear channel types
     */
    clearChannelTypes: createAction(DYNAMIC_CHANNELS.CLEAR_CHANNEL_TYPES),
    
    /**
     * Clear channel instances
     */
    clearChannelInstances: createAction(DYNAMIC_CHANNELS.CLEAR_CHANNEL_INSTANCES),
    
    /**
     * Clear errors and messages
     */
    clearMessages: createAction(DYNAMIC_CHANNELS.CLEAR_MESSAGES),

    /**
     * Fetch dynamic channels from API
     * 
     * @param {JSON} params 
     */
    fetchDynamicChannels (params) {
        return (dispatch, getState) => dynamicGroupsApiService.getDynamicChannels(params)
            .then(response => {
                dispatch(this.saveDynamicChannels(response.data))
            })
            .catch(error => {
                dispatch(this.error(error))
            })
    },

    /**
     * Fetch channel types from API
     * 
     * @param {JSON} params 
     */
    fetchChannelTypes (params) {
        return (dispatch, getState) => dynamicGroupsApiService.getChannelTypes(params)
            .then(response => {
                dispatch(this.saveChannelTypes(response.data, params.entityType))
            })
            .catch(error => {
                dispatch(this.error(error))
            })
    },

    /**
     * Fetch channel instances from API
     * 
     * @param {JSON} params 
     */
    fetchChannelInstances (params) {
        return (dispatch, getState) => dynamicGroupsApiService.getChannelInstances(params)
            .then(response => {
                dispatch(this.saveChannelInstances(response.data, params.channelTypeId))
            })
            .catch(error => {
                dispatch(this.error(error))
            })
    },

    /**
     * Create dynamic channels
     * 
     * @param {JSON} params 
     */
    createDynamicChannels (params) {
        return (dispatch, getState) => dynamicGroupsApiService.postCreateDynamicChannels(params)
            .then(response => {
                dispatch(this.success({
                    header: 'dynamicChannelsActions.create.success.header',
                    content: 'dynamicChannelsActions.create.success.message',
                    refreshData: true,
                    hideMain: true
                }))
                return response
            })
            .catch(error => {
                dispatch(this.error(error))
            })
    },

    /**
     * Clear channel types and instances when entity type changes
     */
    clearChannelData () {
        return (dispatch, getState) => {
            dispatch(this.clearChannelTypes())
            dispatch(this.clearChannelInstances())
        }
    },

    /**
     * Clear only channel instances when channel type changes
     */
    clearInstancesOnly () {
        return (dispatch, getState) => {
            dispatch(this.clearChannelInstances())
        }
    }
}
